import React from "react";
import { Avatar } from "@chakra-ui/react";

const ProfileAvatar = ({ image }) => <Avatar src={image} />;

export default ProfileAvatar;
